import React from 'react'
import './Skills.css'
import resumeFile from '../Assets/ANTUAN-FURTCH-Resume.pdf'

const Skills = () => {
    const skills = [
        { id: 1, name: 'HTML' },
        { id: 2, name: 'CSS' },
        { id: 3, name: 'JavaScript'},
        { id: 4, name: 'React' },
        { id: 5, name: 'Bootstrap' },
        { id: 6, name: 'Figma' },
        { id: 6, name: 'Node.js' },
        { id: 7, name: 'Mongodb' },
        { id: 8, name: 'Express.js' },
        { id: 9, name: 'APIs' },
        { id: 10, name: 'Git' },
        { id: 11, name: 'GitHub' },
        { id: 12, name: 'UI/UX Thinking'},
        { id: 13, name: 'Responsive Design'},
    ]
  return (
    <div className='skills'>
        <div className='title-resume'>
            <h2 className='skills-header'>Skills</h2>
            <a href={resumeFile} download="Antuan-Furtch-Resume.pdf">
                <button className="resume-btn">Download Resume</button>
            </a>
        </div>
        <div className='skills-container'>
            {skills.map((skill) => (
                <div key={skill.id} className='skill-item'>
                    <h3>{skill.name}</h3>
                </div>
            ))}
        </div>
    </div>
  )
}

export default Skills